// Welke bewegingseffecten van de Framer-site aan staan. Zet er één op false om het overal uit te schakelen.
// De server zet de actieve namen op <html data-fx>, zodat de CSS vanaf de eerste paint klopt;
// src/client/motion.ts voert ze uit. Met "minder beweging" of zonder JavaScript blijft alles statisch.

export const motionEffects = {
  /** Lenis-smooth-scroll (Framer-component "Lenis Smooth Scroll", standaardinstellingen). */
  smoothScroll: true,
  /** Navigatie schuift weg bij naar beneden scrollen en komt terug bij naar boven scrollen (0,6s). */
  navHide: true,
  /** Hero blijft vastgepind (sticky, 100vh); de inhoud schuift eroverheen. */
  heroSticky: true,
  /** Parallax: hero op snelheid 120, paginakoppen en kaarten op 92 (data-parallax). */
  parallax: true,
  /** WebGL-laag "Chroma Background / Liquid" (Unicorn Studio) over de hero, enkel vanaf 1200px. */
  heroChroma: true,
  /** Laad-animatie: 30px omhoog en invloeien, 0,8s na 0,4s (data-motion="appear"). */
  appear: true,
  /** In beeld: 30px omhoog met een veer (stiffness 180, damping 60), herhaalt bij terugscrollen (data-motion="rise"). */
  rise: true,
  /** In beeld: 30px omhoog en invloeien, 0,8s na 0,2s, één keer (data-motion="fade-up"). */
  fadeUp: true,
} as const;

export type MotionEffect = keyof typeof motionEffects;

export const activeMotionEffects = (Object.keys(motionEffects) as MotionEffect[]).filter((name) => motionEffects[name]);
